import React, { useEffect, useMemo } from "react";
import { Accordion, Row, Col } from "react-bootstrap";
import { useSelector, useDispatch } from "react-redux";
// import { mapUserRoles } from "../../../../functions/useRoleMapping";
import useHandleBlur from "../../../../functions/useHandleBlur";
// import useTbdCheck from "../../../../functions/useTbdCheck";
import { useFormState } from "../../../../functions/useFormState"; // Reusable form hook
// import {
//   selectUserDetails,
//   selectUserRoles,
// } from "../../../../redux/slices/userSlice";
// import { selectApiUrls } from "../../../../redux/slices/apiUrlSlice";
import { selectPumps, selectPumpDetails } from "../../../../redux/selectors";
import { mapUserRoles } from "../../../../functions/useRoleMapping";
import {
  selectUserRoles,
} from "../../../../redux/slices/userSlice";
import SustainPump from "./SustainPump";
import MainPump from "./MainPump";
import WaterFeaturePump from "./WaterFeaturePump";
import TransferPump from "./TransferPump";
import RecirculationPump from "./RecircPump";
import TrashPump from "./TrashPump";
import PumpTable from "./PumpTable";
import { updateActivePumps } from '../../../../redux/slices/activePumpsSlice';
import { setJobDetail } from '../../../../redux/slices/jobDetailsSlice'; // Import the correct action to update job details
import SelectedPumps from "./selectedPumps";
import SumpPump from "./SumpPump"; // Import the SumpPump component
import OtherPump from "./CustomPump"; // Import the OtherPump component for undefined pump types
import NoRecordFoundAlert from "../../../common/NoRecordFoundAlert";
import { normalizePumpId } from "./pumpIdHelpers";

const Pumps = ({ zone }) => {
  const dispatch = useDispatch();
  const storedJobDetails = useSelector(selectPumps);
  const userRoles = useSelector(selectUserRoles); // User details
  const roles = useMemo(() => mapUserRoles(userRoles), [userRoles]);
  const pumpDetails = useSelector(selectPumpDetails);
  // const { options } = useSelector((state) => state.dropdown);
  const activetab = useSelector(
    (state) => state.activeMechanicalTab.selectedZone
  );

  // const tbdItems = useSelector((state) => state.tbdApi.tbdList);
  // const jobTbdItems = tbdItems?.filter(
  //   (item) => item.ProjectID === String(storedJobDetails[0]?.ProjectID)
  // );

  // const pumpTbdItems = pumpDetails.map((pump) => 
  //   jobTbdItems.find((item) => item.ObjectID === pump.ID)
  // );

  // console.log("pumpTbdItems", pumpTbdItems);


  // const jockeySequenceOptions =
  //   options?.filter((option) => option.DropdownType === "Jockey Sequence").sort((a, b) => a.SortOrder - b.SortOrder) || [];

  // const loading = storedJobDetails.length === 0;
  const loading = false;
  const error = null;

  const { formData, setFormData } = useFormState({});

  const jobDetails = useMemo(() => {
    const detail = storedJobDetails.find((detail) => detail.Zone === activetab);
    return detail || storedJobDetails[0] || {};
  }, [storedJobDetails, activetab]);

  useEffect(() => {
    if (jobDetails) {
      setFormData({
        ID: jobDetails.ID || "",
        comments: jobDetails.Comments || "",
        pumpType: jobDetails.PumpType || "",
        pumpCapacity: jobDetails.PumpCapacity || "",
      });
    }
  }, [dispatch, jobDetails, setFormData]);

  const { showNotification, saveStatus } = useHandleBlur(formData);

  const handlePumpsChange = () => {
    const updatedJobDetail = storedJobDetails.find((detail) => detail.Zone === activetab);
    dispatch(updateActivePumps(updatedJobDetail.ID)); // Dispatch the thunk to update active pumps
    dispatch(setJobDetail(updatedJobDetail)); // Use the correct action to update job details
  };

  // const isValueInDropdown = (value, dropdownOptions) => {
  //   return dropdownOptions.some(
  //     (option) => option.DisplayText === value || option.displayName === value
  //   );
  // };

  // const { tbdFields } = useTbdCheck(formData, zone);
  // const zoneTbdFields = zone ? tbdFields?.[zone] : tbdFields;


  if (loading) {
    return (
      <div className="d-flex justify-content-center align-items-center">
        <div className="spinner-border" role="status">
          <span className="visually-hidden">Loading...</span>
        </div>
      </div>
    ); // Show loading spinner
  }

  if (error) {
    return <div className="error">{error}</div>; // Show error message if fetch fails
  }

  if (!loading && !jobDetails?.ID) {
    return (
      <NoRecordFoundAlert sectionName={"pumps"} zone={zone} />
    );
  }

  // Restrict pump checks to the currently selected zone only
  const normalize = (v) => (v == null ? "" : String(v));
  const currentZonePumps = (pumpDetails || []).filter((p) => normalize(p.Zone) === normalize(activetab));

  return (
    <div className="pumps-responsive">
      <PumpTable onPumpsChange={handlePumpsChange} isJobMechInfo={true} />
      {error ? (
        <p style={{ color: "red" }}>Error: {error}</p>
      ) : !formData ? (
        <p>Loading...</p>
      ) : (
        <div>
          <div>
            {showNotification && (
              <div
                className={`save-notification ${
                  saveStatus.includes("Failed") ? "error" : ""
                }`}
              >
                {saveStatus}
              </div>
            )}
          </div>

          <Accordion className="pumps-accordion">
          {roles.Apps || roles.Admin ? ( // Render accordion only for Apps or Admin roles
            <Accordion.Item eventKey="0">
              <Accordion.Header>
                <Row className="w-100 align-items-center pump-accordion-header-row">
                  <Col>
                    <h3>Sales Portal Selected Pumps</h3>
                  </Col>
                </Row>
              </Accordion.Header>
              <Accordion.Body>
                <SelectedPumps />
              </Accordion.Body>
            </Accordion.Item>
          ) : null}
            {[
              { name: "Pressure Maintenance Pump", component: SustainPump, pumpID: "pm" },
              { 
                name: "Main Pump(s)", 
                component: MainPump, 
                pumpID: "main", 
                additionalCondition: (pump) => pump.PumpID && pump.PumpID.toLowerCase() === "jockey" 
              },
              { name: "Water Feature Pump", component: WaterFeaturePump, pumpID: "water feature" },
              { name: "Transfer Pump", component: TransferPump, pumpID: "transfer" },
              { name: "Recirculation Pump", component: RecirculationPump, pumpID: "recirculation" },
              { name: "Trash Pump", component: TrashPump, pumpID: "trash" },
              { name: "Sump Pump", component: SumpPump, pumpID: "sump" }, // Add Sump Pump option
              { 
                name: "Other Pumps", 
                component: OtherPump, 
                isOtherPump: true, 
                condition: (pump, definedTypes) => {
                  // Check if pump has a PumpID that doesn't match any defined types
                  if (!pump.PumpID) return true; // Include pumps with no PumpID
                  const lowerCasePumpID = normalizePumpId(pump.PumpID);
                  return !definedTypes.some(type => {
                    if (type.pumpID && lowerCasePumpID === type.pumpID) return true;
                    if (type.additionalCondition && type.additionalCondition(pump)) return true;
                    return false;
                  });
                }
              },
            ].map((section, index) => {
              const SectionComponent = section.component;

              // Check if it's the "Other Pumps" section which needs special handling
              let pumpExists = false;

              if (section.isOtherPump) {
                // For Other Pumps section, check if there are any pumps in this zone that don't match defined types
                const definedSections = [
                  { pumpID: "pm" },
                  { pumpID: "main", additionalCondition: (p) => p.PumpID && p.PumpID.toLowerCase() === "jockey" },
                  { pumpID: "water feature" },
                  { pumpID: "transfer" },
                  { pumpID: "recirculation" },
                  { pumpID: "trash" },
                  { pumpID: "sump" }
                ];

                pumpExists = currentZonePumps.some(pump => section.condition(pump, definedSections));
              } else {
                // Standard check for defined pump types, limited to current zone
                pumpExists = currentZonePumps.some(
                  (pump) =>
                    pump.PumpID && (
                    normalizePumpId(pump.PumpID) === section.pumpID ||
                    (section.additionalCondition && section.additionalCondition(pump))
                    )
                );
              }

              if (!pumpExists) return null;

              // Find pumps of this section type in the current zone only
              let sectionPumps;

              if (section.isOtherPump) {
                const definedSections = [
                  { pumpID: "pm" },
                  { pumpID: "main", additionalCondition: (p) => p.PumpID && p.PumpID.toLowerCase() === "jockey" },
                  { pumpID: "water feature" },
                  { pumpID: "transfer" },
                  { pumpID: "recirculation" },
                  { pumpID: "trash" },
                  { pumpID: "sump" }
                ];

                sectionPumps = currentZonePumps.filter(pump => section.condition(pump, definedSections));
              } else {
                sectionPumps = currentZonePumps.filter(pump => 
                  pump.PumpID && (
                  normalizePumpId(pump.PumpID) === section.pumpID ||
                  (section.additionalCondition && section.additionalCondition(pump))
                  )
                );
              }

              // Helper function to check if a value contains 'tbd'
              const containsTbd = (value) => {
                if (typeof value === 'string' && value) {
                  return value.toLowerCase().includes('tbd');
                }
                return false;
              };

              // Check if any pump has a field containing 'tbd'
              const hasTbd = sectionPumps.some(pump => 
                Object.values(pump).some(value => containsTbd(value))
              );

              return (
                <Accordion.Item
                  eventKey={String(index + 1)}
                  key={section.name}
                >
                  <Accordion.Header>
                    <Row className="w-100 align-items-center pump-accordion-header-row">
                      <Col>
                        <h3>
                          {hasTbd && (
                            <i
                              className="bi bi-exclamation-diamond-fill"
                              style={{ color: "red" }}
                            />
                          )} {section.name}
                        </h3>
                      </Col>
                    </Row>
                  </Accordion.Header>
                  <Accordion.Body>
                    {SectionComponent && (
                      <div className="pump-component-responsive">
                        <SectionComponent
                          zone={zone}
                          pumpData={section.isOtherPump ? sectionPumps : null}
                        />
                      </div>
                    )}
                  </Accordion.Body>
                </Accordion.Item>
              );
            })}
          </Accordion>
        </div>
      )}
      
    </div>
  );
};
export default Pumps;
